import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadStopsByIdFailed, loadStopsByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_MDS_URL } from '../../../configs';

export default function* loadStopsById(action) {
  try {
    const url = `${BACKEND_MDS_URL}/agency/vehicles/stops/${action.payload.id}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadStopsByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadStopsByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadStopsByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
